"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class EmailNotValidError extends client_library_1.ExtendableError {
    constructor(email) {
        super(`Invalid email: ${email}`);
        this.email = email;
    }
}
exports.default = EmailNotValidError;
//# sourceMappingURL=EmailNotValidError.js.map